import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { CountryCode } from '../../config';
//import { SpecialityTypes } from '../../config/RayCodes';
import { InstallationAction, ErrorCodeAction, ProductAction, SiteAction } from '../../actions';
import { RayForm, RayFormValidation } from '../common';
import { useTranslation } from 'react-i18next';
import { Translate as t } from '../../config/Translate';

const InstallationStep1 = ({ info, site, UpdateSite, GetSite, Update, isSummary = false, user, gostep }) => {
	// const [ t, i18n ] = useTranslation();
	const [errors, setErrors] = useState([]);
	const [installation, setInstallation] = useState(info);
	const [siteInfo, setSiteInfo] = useState(site || {});
	const [updateSiteInfo, setUpdateSiteInfo] = useState({});

	const SpecialityTypes = [
		{ code: "GP", title: t('user.type.generalPractitioner') },
		{ code: "Pros", title: t('user.specialty.prosthodontist') },
		{ code: "Endo", title: t('user.specialty.endodontist') },
		{ code: "Perio", title: t('user.specialty.periodontist') },
		{ code: "Ortho", title: t('user.specialty.orthodontist') },
		{ code: "Ped", title: t('user.specialty.pediatricDentist') },
		{ code: "Oral", title: t('user.specialty.oralMaxillofacialSurgeon') },
		{ code: "Public", title: t('user.specialty.publicHealthDentist') },
		{ code: "Rad", title: t('user.specialty.radiologist') },
		{ code: "Other", title: t('common.label.other') },
	]

	useEffect(() => {
		setSiteInfo(site || {});
	}, [site]);

	useEffect(() => {
		if (info.siteId) {
			GetSite(info.siteId);
			setInstallation(info);
		}
	}, [info]);

	const handleChangeData = (e) => {
		const { name, value } = e.target;
		setSiteInfo(prev => ({ ...prev, [name]: value }));
		setUpdateSiteInfo(prev => ({ ...prev, [name]: value }));
	};

	const form_controls = [
		{
			title: t('site.field.practice'), items: [
				{ type: "input", name: "sitename", label: t('site.field.siteName'), val: siteInfo.sitename, isEditable: !isSummary },
				{ type: "select", name: "speciality", label: t('site.field.specialty'), val: siteInfo.speciality, list: SpecialityTypes, isEditable: !isSummary }
			]
		},
		{
			title: "", items: [
				{ type: "tel", name: "tel", label: t('common.field.tel'), val: siteInfo.tel, isEditable: !isSummary },
				{ type: "tel", name: "fax", label: t('common.field.fax'), val: siteInfo.fax, isEditable: !isSummary }
			]
		},
		{
			title: "", items: [
				{ type: "email", name: "email", label: t('common.field.email'), val: siteInfo.email, isEditable: !isSummary },
				{ type: "tel", name: "hp", label: t('common.field.mobile'), val: siteInfo.hp, isEditable: !isSummary }
			]
		},
		{
			title: "", items: [
				{ type: "input", name: "address", label: t('common.field.address'), val: siteInfo.address, isEditable: !isSummary },
			]
		},
		{
			title: "", items: [
				{ type: "input", name: "zipcode", label: t('common.field.zipCode'), val: siteInfo.zipcode, isEditable: !isSummary },
				{ type: "select", name: "country", label: t('common.field.country'), val: !siteInfo.country ? (user?.companyInfo?.country ?? "") : siteInfo.country, list: CountryCode, isEditable: !isSummary }
			]
		},
		{
			title: "", items: [
				{ type: "input", name: "website", label: t('common.field.website'), val: siteInfo.website, isEditable: !isSummary }
			]
		},

		{
			title: t('common.label.customer'), items: [
				{ type: "input", name: "customerFirstName", label: t('common.field.firstName'), val: siteInfo.customerFirstName, isEditable: !isSummary },
				{ type: "input", name: "customerLastName", label: t('common.field.lastName'), val: siteInfo.customerLastName, isEditable: !isSummary },
				{ type: "email", name: "customerEmail", label: t('common.field.email'), val: siteInfo.customerEmail, isEditable: !isSummary },
				{ type: "tel", name: "customerHp", label: t('common.field.mobile'), val: siteInfo.customerHp, isEditable: !isSummary }
			]
		},
	];

	const [isSubmitting, setIsSubmitting] = useState(false);

	// 현재 입력(사이트 정보)과 목표 단계를 함께 저장. '다음'·'이전'·상단 이동이 같이 쓴다.
	const saveStep = async (targetStep, alwaysSaveSite) => {
		setIsSubmitting(true);
		try {
			if (alwaysSaveSite || Object.keys(updateSiteInfo).length > 0) {
				await UpdateSite(installation.siteId, updateSiteInfo);
			}
			await Update(installation._id, { ...installation, installationStep: targetStep });
		} catch (error) {
			console.error('InstallationStep1 saveStep error:', error);
		} finally {
			setIsSubmitting(false);
		}
	};

	const Prev = (e) => {
		saveStep(1, false);
	};

	const validNext = async (targetStep = 3) => {
		const errValidate = RayFormValidation(form_controls, siteInfo);
		if (errValidate.length > 0) {
			setErrors(errValidate);
			return;
		}
		await saveStep(targetStep, true);
	};

	// 상단 배지·◀▶ 이동: 이 단계 검증을 통과하면 현재 입력과 함께 목표 단계로 저장, 실패하면 오류만 표시.
	useEffect(() => {
		if (gostep && gostep.curStep == 2) {
			validNext(gostep.goStepNo);
		}
	}, [gostep]);

	return (
		<>
			<RayForm controls={form_controls} isSummary={isSummary} isForm={!isSummary} handleChangeData={handleChangeData} errors={errors} />
			{!isSummary && <div className="section mt-1 mb-2">
				<button className={isSubmitting ? "btn btn-primary btn-block btn-lg disabled" : "btn btn-primary btn-block btn-lg"} onClick={() => !isSubmitting && validNext()}>{isSubmitting ? t('common.status.processing') || 'Processing...' : t('common.button.next')}</button>
				<button className="btn btn-dark btn-block btn-lg mt-1" onClick={() => Prev()}>{t('common.button.back')}</button>
			</div>}
		</>
	);
};

const mapState = (state) => {
	const site = state.SiteReducer.site;
	const user = state.AuthReducer.user;
	return { site, user };
}

const mapDispatch = (dispatch) => ({
	GetSite: (siteId) => dispatch(SiteAction.GetSite(siteId)),
	Update: (_id, data) => dispatch(InstallationAction.UpdateInstallation(_id, data)),
	UpdateSite: (siteId, data) => dispatch(SiteAction.UpdateSiteInfo(siteId, data)),
});

export default connect(mapState, mapDispatch)(InstallationStep1);